import { colors } from '@atlaskit/theme';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import React from 'react';
import Tooltip from 'components/common/Tooltip';
import { FormattedMessage } from 'react-intl';
import { messages } from 'modules/mac/messages';

export const SearchTooltip: React.FC = () => (
  <Tooltip
    direction="up-middle"
    content={
      <div style={{ textAlign: 'center' }}>
        <FormattedMessage {...messages.searchTip} />
      </div>
    }
  >
    <QuestionCircleIcon size="small" primaryColor={colors.N80} label="help" />
  </Tooltip>
);
